import PropTypes from 'prop-types';
import React from 'react';
import { useAccountOrMembershipRequiredModalContext } from '../../Anonymous/AccountOrMembershipRequiredModal/contexts/AccountOrMembershipRequiredModalContext';
import { useUser } from '../../User/containers/UserDataStore';
import BadgeType from '../BadgeType';
import { useComments } from '../containers/commentsDataStore';
import ConversationStatus from '../ConversationStatus';

BadgeActions.propTypes = {
	comment: PropTypes.object,
	toggleEditMode: PropTypes.func,
};

export default function BadgeActions({ comment, toggleEditMode }) {
	const commentsDataStore = useComments();
	const { setIsVisible } = useAccountOrMembershipRequiredModalContext();
	const {
		state: {
			user: { user },
		},
		isAnonymous,
	} = useUser();

	const isOwner = user && user.id === comment.appUserId;

	const toggleBadge = badgeType => {
		commentsDataStore.toggleBadge(comment.id, badgeType.key);
	};

	const toggleDeleteNote = commentId => {
		commentsDataStore.changeCommentStatus(
			commentId,
			ConversationStatus.deleted,
		);
	};

	const renderBadge = badgeType => {
		return (
			<div
				key={badgeType.key}
				className={`column-spaced clickable ${badgeType.icon}`}
				onClick={() =>
					isAnonymous() ? setIsVisible(true) : toggleBadge(badgeType)
				}></div>
		);
	};

	return (
		<div className="hidden-anchor badge-action">
			<div
				style={{
					paddingLeft: '10px',
					paddingRight: '10px',
				}}>
				{Object.keys(BadgeType).map(badgeType =>
					renderBadge(BadgeType[badgeType]),
				)}
				{isOwner && (
					<React.Fragment>
						<div
							className="column-spaced icon-note-icon clickable"
							onClick={() => toggleEditMode()}></div>
						<div
							className="column-spaced icon-delete-icon clickable"
							onClick={() => toggleDeleteNote(comment.id)}></div>
					</React.Fragment>
				)}
				<div className="clear" />
			</div>
		</div>
	);
}
